module.exports = __webpack_public_path__ + "media/images/common/app_googleplay-fde732b1c1900fb7b52af23a3655d574.png";